module.exports = __webpack_public_path__ + "img/pdf.7a144bb0.png";